/**
 * @export
 * @class WindowEvent
 * window 객체의 이벤트를 관리
 */
export default class WindowEvent {
  bScrolling = false;

  constructor() {
    this.setEvent();
    this.onScroll();
  }

  setEvent() {
    $(window).on('scroll', $.proxy(this.onScroll, this));
    $(window).on('resize', $.proxy(this.onResize, this));
  }

  clearEvent() {
    $(window).off('scroll');
    $(window).off('resize');
  }

  /**
   * window.onScroll 이 발생했을 때 호출. scroll event 에 의해 너무 잦은 UI 변경이 발생하는 것을 막기 위해 일정 시간을 기준으로 throttle
   */
  onScroll() {
    const nThrottleTime = 30;
    if (TMON.oApp.sPlatform === 'PW') {
      this.scrollAction();
      return;
    }
    if (!this.bScrolling) {
      this.bScrolling = true;
      setTimeout(() => {
        this.scrollAction();
        this.bScrolling = false;
      }, nThrottleTime);
    }
  }

  /**
   * throttle 을 통해 scroll action 이 결정되면 TMON.oApp 에 scrolling 사실을 전달해 줌. 현재 window.scrollTop 값을 매개변수로 넘김
   */
  scrollAction() {
    const nScrollTop = $(window).scrollTop();
    TMON.oApp.onScroll(nScrollTop);
  }

  /**
   * window.onResize 이 발생했을 때 호출. resize event 에 의해 너무 잦은 UI 변경이 발생하는 것을 막기 위해 일정 시간을 기준으로 throttle
   */
  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.resizeAction();
    }, 250);
  }

  /**
   * throttle 을 통해 resize action 이 결정되면 TMON.oApp 에 resize 사실을 전달해 줌
   */
  resizeAction() {
    TMON.oApp.onResize();
  }
}
